import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../UIComponents/Breadcrumb'
import BlogsSection from '../../components/Blogs/BlogsSection'
import { Fragment } from 'react'
import Head from 'next/head'
import MetaTags from '../MetaTags/MetaTags'

const Blogs = (props: any) => {
	const data = { name: 'Blog' }
	const [searchBlogs, setsearchBlogs] = useState(props?.blogs)
	const [currentFilter, setCurrentFilter] = useState(props?.type || 'all')

	useEffect(() => {
		setsearchBlogs(props?.blogs)
	}, [props?.blogs])

	return (
		<Fragment>
			<MetaTags title={'Dental Blog | GerDentUSA'} description={'Explore the GerDentUSA blog for the latest articles on dental care, product updates, industry trends, and expert tips to enhance your dental practice.'} />
			<Breadcrumb data={data} />
			{/* <BlogsSearch setsearchBlogs={setsearchBlogs} 
         currentFilter={currentFilter}
         setCurrentFilter={setCurrentFilter}/> */}
			<BlogsSection searchBlogs={searchBlogs} setsearchBlogs={setsearchBlogs} currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} />
		</Fragment>
	)
}

export default Blogs
